
import { Chip } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment-timezone';
import React from 'react';
import EnhancedTableHead, { getSorting, HeadRow, Order, sortRows } from '../../common/EnhancedTableHead';
import LinkRouter from '../../common/LinkRouter';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tag: {
      margin: '4px 4px 4px 0'
    },
    versionCol: {
      maxWidth: 200,
      width: 200,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    tagsCol: {
      width: 300
    }
  })
);

interface Props {
  decks: any[];
  page: number;
  onPageChange: (newPage: number) => void;
}

const headRows: HeadRow[] = [
  { id: 'deckName', disablePadding: true, label: 'Deck Name' },
  { id: 'version', disablePadding: true, label: 'Version' },
  { id: 'buildDate', disablePadding: true, label: 'Last Update' },
  { id: 'tags', disablePadding: true, label: 'Tags', disableSorting: true }
];

function FaroDecksTable(props: Props) {
  const { decks, page, onPageChange } = props;
  const classes = useStyles({});

  const [order, setOrder] = React.useState<Order>('desc');
  const [orderBy, setOrderBy] = React.useState<string>('buildDate');
  const [rowsPerPage, setRowsPerPage] = React.useState(20);

  function handleRequestSort(event: React.MouseEvent<unknown>, property: string) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    onPageChange(0);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    onPageChange(newPage);
  };

  const sortedRows = sortRows(decks || [], getSorting(order, orderBy));

  return (
    <div>
      <Table>
        <EnhancedTableHead
          order={order}
          orderBy={orderBy}
          fields={headRows}
          onRequestSort={handleRequestSort}
        />
        <TableBody>
          {sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => (
            <TableRow key={`${row.deckName}::${row.version}`}>
              <TableCell>
                <LinkRouter variant="body1" to={`/faro/decks/${row.deckName}?version=${encodeURIComponent(row.version)}`}>{row.deckName}</LinkRouter>
              </TableCell>
              <TableCell className={classes.versionCol}>
                {row.version}
              </TableCell>
              <TableCell>
                {row.buildDate ? moment(row.buildDate).fromNow() : 'n/a'}
              </TableCell>
              <TableCell className={classes.tagsCol}>
                {row.tags.map(tag => <Chip key={tag} size="small" className={classes.tag} label={tag} variant="outlined" />)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={decks.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          'aria-label': 'previous page',
        }}
        nextIconButtonProps={{
          'aria-label': 'next page',
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default FaroDecksTable;
